import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  endButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    marginTop: '1rem'
  },

  yesButton: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main
  }
}))

export default useStyles
